import React from 'react';
import './style.scss';

const LoadingIndicator = () => (
  <div className="loading-indicator">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default LoadingIndicator;
